import { z } from 'zod';

/*
 * Без компиляции схем через Function(): Content-Security-Policy сайта
 * запрещает eval (scripts/csp.ts), и проверка его доступности, которую Zod
 * делает перед первым разбором, оставляла бы нарушение CSP на каждой
 * загрузке страницы. Вызов стоит до схемы ниже — это первый разбор в
 * клиенте.
 */
z.config({ jitless: true });

/**
 * Клиентское окружение.
 *
 * Здесь могут находиться ТОЛЬКО переменные с префиксом VITE_ — всё, что
 * попадает в бандл, публично и считается известным атакующему. Серверные
 * секреты (service role, ключи AI-провайдера) живут исключительно в
 * Supabase Edge Functions и в этот файл не попадают никогда.
 */
const clientEnvSchema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
});

export type ClientEnv = z.infer<typeof clientEnvSchema>;

const parsed = clientEnvSchema.safeParse({
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
});

/**
 * Настроено ли подключение к Supabase.
 *
 * Приложение намеренно не падает при отсутствии переменных: без credentials
 * оно должно запускаться и честно показывать, что backend не подключён,
 * а не выдавать белый экран.
 */
export const isSupabaseConfigured = parsed.success;

export const env: ClientEnv = parsed.success
  ? parsed.data
  : { VITE_SUPABASE_URL: '', VITE_SUPABASE_ANON_KEY: '' };

/** Причины, по которым окружение считается ненастроенным. Для экрана диагностики. */
export const envIssues: readonly string[] = parsed.success
  ? []
  : parsed.error.issues.map((issue) => `${issue.path.join('.')}: ${issue.message}`);

export const isDev = import.meta.env.DEV;
